import http from "../../http-common";

const getAllPlatforms = async () => {
  return await http
    .get("/admin/platforms/")
    .then((r) => r.data)
    .catch((error) => {
      throw error.response?.data || error.response || error;
    });
};

const createPlatform = async (platform) => {
  return await http
    .post("/admin/platforms/", platform)
    .then((r) => r.data)
    .catch((error) => {
      throw error.response?.data || error.response || error;
    });
};

const uploadMedia = async (id, formData) => {
  return await http
    .post(`/admin/platforms/${id}/upload-image`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })

    .then((r) => r.data)
    .catch((error) => {
      throw error.response?.data || error.response || error;
    });
};

const getPlatformById = async (id) => {
  return await http
    .get(`/admin/platforms/${id}`)
    .then((r) => r.data)
    .catch((error) => {
      throw error.response?.data || error.response || error;
    });
};


const update = async (id, data) => {
  return await http

    .put(`/admin/platforms/${id}`, data)
    .then((r) => r.data)
    .catch((error) => {
      throw error.response?.data || error.response || error;
    });
};

const getPlatformDeployment = async (id) => {
  return await http
    .get(`/admin/platforms/${id}/deployment`)
    .then((r) => r.data)
    .catch((error) => {
      throw error.response?.data || error.response || error;
    });
};

const createPlatformDeployment = async (id) => {
  return await http
    .post(`/admin/platforms/${id}/deployment`)
    .then((r) => r.data)
    .catch((error) => {
      throw error.response?.data || error.response || error;
    });
};

const getPlatformGateways = async (id) => {
  return await http
    .get(`/admin/platforms/${id}/gateways`)
    .then((r) => r.data)
    .catch((error) => {
      throw error.response?.data || error.response || error;
    });
};

const updateGateway = async (id, gatewayCode, data) => {
  return await http
    .put(`/admin/platforms/${id}/gateways/${gatewayCode}`, data)
    .then((r) => r.data)
    .catch((error) => {
      throw error.response?.data || error.response || error;
    });
};

const updateRules = async (id, paymentType, data) => {
  return await http
    .put(`/admin/platforms/${id}/gateways/rules/${paymentType}`, data)
    .then((r) => r.data)
    .catch((error) => {
      throw error.response?.data || error.response || error;
    });
};

// Categories
const getCategories = async (platformId) => {
  return await http
    .get(`/admin/platforms/${platformId}/categories`)
    .then((r) => r.data)
    .catch((error) => {
      throw error.response?.data || error.response || error;
    });
};

const createCategory = async (platformId, category) => {
  return await http
    .post(`/admin/platforms/${platformId}/categories`, category)
    .then((r) => r.data)
    .catch((error) => {
      throw error.response?.data || error.response || error;
    });
};

const updateCategory = async (platformId, categoryId, category) => {
  return await http
    .put(`/admin/platforms/${platformId}/categories/${categoryId}`, category)
    .then((r) => r.data)
    .catch((error) => {
      throw error.response?.data || error.response || error;
    });
};

const deleteCategory = async (platformId, categoryId) => {
  return await http
    .delete(`/admin/platforms/${platformId}/categories/${categoryId}`)
    .then((r) => r.data)
    .catch((error) => {
      throw error.response?.data || error.response || error;
    });
};

const uploadCategoryIcon = async (platformId, categoryId, file) => {
  const formData = new FormData();
  formData.append('file', file);
  
  return await http
    .post(`/admin/platforms/${platformId}/categories/${categoryId}/upload-icon`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    .then((r) => r.data)
    .catch((error) => {
      throw error.response?.data || error.response || error;
    });
};

// Ultimate
const forceAllDeployments = async () => {
  return await http
    .post(`/ultimate/platforms/deployments/force-all`)
    .then((r) => r.data)
    .catch((error) => {
      throw error.response?.data || error.response || error;
    });
};

export default {
  getAll: getAllPlatforms,
  create: createPlatform,
  update: update,
  uploadMedia: uploadMedia,
  getById: getPlatformById,
  getDeployment: getPlatformDeployment,
  createDeployment: createPlatformDeployment,
  getGateways: getPlatformGateways,
  updateGateway: updateGateway,
  updateRules: updateRules,

  // Categories
  getCategories: getCategories,
  createCategory: createCategory,
  updateCategory: updateCategory,
  deleteCategory: deleteCategory,
  uploadCategoryIcon: uploadCategoryIcon,

  // Ultimate
  forceAllDeployments: forceAllDeployments,
};

